import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { DEFAULT_DOMAIN } from '../../config/domains';

interface BrandLogoProps {
  brand?: string | null;
  className?: string;
  variant?: 'light' | 'dark';
  source?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ brand, className = "h-20 w-auto", variant = 'light', source }) => {
  const theme = useTheme();

  // No source prop: use current theme domain (e.g. sidebar logo)
  // Source prop but falsy (null from DB): use DEFAULT_DOMAIN
  // Source prop with value: use that value
  let domain = source === undefined ? theme.domain : (source || DEFAULT_DOMAIN);

  // Backward compatibility: Handle legacy 'brand' query parameter
  if (brand === 'pp' && !source) {
    domain = 'onboarding.processingpartners.com';
  }

  // Look up config from API-driven configs
  const domainConfig = theme.allConfigs.get(domain);

  if (!domainConfig) {
    // Fall back to current theme's logo
    const logoSrc = theme.logos[variant];
    return <img src={logoSrc} alt={theme.brandName} className={className} />;
  }

  const logoSrc = domainConfig.logos[variant];

  return <img src={logoSrc} alt={domainConfig.brandName} className={className} />;
};

export default BrandLogo;
